import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { debounce } from '../../../../../helpers/common'
import useDidUpdateEffect from '../../../../hooks/useDidUpdateEffect'
import { Checkbox } from '../../../../html/checkbox'
import { Element } from '../../../../html/element'
import { Icon } from '../../../../html/icon'
import { InputDropdown } from '../../../../html/input/InputDropdown'
import { Loading } from '../../../../loading'
import { ScrollComponent } from '../../../../scrollComponent'
import { SCROLL_COMPONENT_IDS } from '../../../constant'
import {
  changeListSelectedCompany,
  changeTextSearchCompany,
  loadingPortfolio,
  selectDataSearchCompanyExclude,
  selectListSelected,
  selectListSelectedCompanyExclude,
  selectTextSearchCompany,
} from '../../../store/slicePortfolio'
import { getSearchExcludeCompanyInPortfolio } from '../../../store/thunk'

export const InputSearchCompanyExclude = () => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataSearchCompanyExclude)
  const listIdsSelected = useSelector(selectListSelectedCompanyExclude)
  const textSearch = useSelector(selectTextSearchCompany)
  const listIdPort = useSelector(selectListSelected)
  const loading = useSelector(loadingPortfolio('searchCompany'))

  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [inputValue, setInputValue] = useState(textSearch)

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        getSearchExcludeCompanyInPortfolio({
          term: value,
          page: 1,
          pageSize: 300,
          portfolioIds: listIdPort.map((item) => item.value),
        }),
      )
    }, 700),
    [listIdPort],
  )

  const clearText = () => {
    dispatch(changeTextSearchCompany(''))
    setInputValue('')
  }

  const handleChoose = (item) => {
    dispatch(
      changeListSelectedCompany({
        value: item.organizationId,
        label: item.organizationName,
      }),
    )
  }

  const handleOpenDropdown = () => {
    setIsShowDropdown(true)
    !data.length && handleChangeText(textSearch)
  }

  const handleHideDropdown = () => {
    setIsShowDropdown(false)
    clearText()
  }

  const renderDropdown = () => {
    if (loading) {
      return <Loading style={{ backgroundColor: '#FFFFFF' }} />
    }

    if (!data || !data.length) {
      return (
        <div className="fstItalic">
          <Translate value="library.main.NODATA_SEARCH_COMPANY" />
        </div>
      )
    }

    return (
      <ScrollComponent autoHeight autoHeightMax={400}>
        {data.map((item) => (
          <DropdownItem
            key={item?.organizationId}
            item={item}
            handleChoose={handleChoose}
            listIdsSelected={listIdsSelected}
          />
        ))}
      </ScrollComponent>
    )
  }

  useDidUpdateEffect(() => {
    handleChangeText(inputValue)
  }, [inputValue])

  return (
    <InputDropdown
      placeHolder="library.filterSetting.EXCLUDE"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      isShowDropdown={isShowDropdown}
      setIsShowDropdown={setIsShowDropdown}
      onClickOutsideDropdown={handleHideDropdown}
      onClick={handleOpenDropdown}
      inputProps={{
        style: { fontSize: 12 },
        noControl: true,
        isShowIcon: false,
        customElement: (
          <Icon
            className="icon-caret-bottom pointerEventsNone"
            style={{
              fontSize: 8,
              left: 'unset',
              right: 4,
            }}
          />
        ),
      }}
      dropdownContainerStyle={{
        minWidth: loading || !data || !data.length ? 'unset' : 400,
        minHeight: 50,
      }}
      scrollId={SCROLL_COMPONENT_IDS}
    >
      {renderDropdown()}
    </InputDropdown>
  )
}

export const DropdownItem = ({ item, handleChoose, listIdsSelected }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      onClick={() => {
        handleChoose(item)
      }}
      className="cursorPointer"
    >
      <Element style={{ borderBottom: '1px solid #D5D5D5' }}>
        <Checkbox
          title={item.organizationName}
          checked={listIdsSelected
            .map((item) => item.value)
            .includes(item.organizationId)}
          isCheckOnClickText
          styleIcon={{ fontSize: 15, paddingRight: 8 }}
          style={{ padding: '6px 0' }}
          onChange={() => {
            handleChoose(item)
          }}
        />
      </Element>
    </Element>
  )
}
